module.exports = __webpack_public_path__ + "assets/img/on5-cb3e7f35.png";